import { Request } from '../../../httpClient/serverApi/requests/Request';
import { IResult } from '../../../httpClient/serverApi/types/IResponse';

export interface SetSimulationNameParams {
  readonly id: string;
  readonly name: string;
}

export interface SetSimulationNameResult extends IResult {
}

export class SetSimulationNameRequest extends Request<SetSimulationNameParams, SetSimulationNameResult> {
  constructor(params: SetSimulationNameParams) {
    super('setSimulationName', params);
  }
}
